import { overrideStyledVariantValue } from '~/utilities/override-styled-variant-value/overrideStyledVariantValue'

const toIconSize = {
  sm: 'sm',
  md: 'md',
  lg: 'md'
}

export const getFieldIconSize = (size: any) =>
  overrideStyledVariantValue(size, (s) => toIconSize[s])
